import {
  ICianApiSiteV1GetRegionsResponse,
  ICianApiSiteV1GetRegionsResponse200,
  ICianApiSiteV1GetRegionsResponse400,
  createCianApiSiteV1GetRegionsModel,
  fetchCianApiSiteV1GetRegions,
} from 'shared/repositories/monolith-python/cian-api/site/v1/get-regions';
import { FetchAssertsService } from 'shared/services/FetchAssertsService';
import { IApplicationContext } from 'shared/types/applicationContext';

export async function fetchGetRegionsService(
  dependencies: IApplicationContext,
): Promise<ICianApiSiteV1GetRegionsResponse> {
  const {
    httpApi,
    custom: { subdomain },
    logger,
  } = dependencies;

  const fetchAssertsService = new FetchAssertsService(
    createCianApiSiteV1GetRegionsModel(),
    'src/shared/store/serverSide/monolith-python/cian-api/site/v1/get-regions/internal/fetchService.ts',
    logger,
  );

  return fetchCianApiSiteV1GetRegions<ICianApiSiteV1GetRegionsResponse200, ICianApiSiteV1GetRegionsResponse400>({
    config: { subdomain },
    httpApi,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError({ response: result.response.data });
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
